import { useMemo, useState, useEffect } from "react";
import { Box, Fab, Stack } from "@mui/material";
import { Easing } from "react-native-web";
import { Emoji, Picker } from "emoji-mart";
import Fly from "react-flying-objects";
import data from "@emoji-mart/data";
import { init } from "emoji-mart";
import { AppSingleton } from "../services/user_config";
import { sendEmojiAPI } from "../services/backend";

init({ data });

const DELAY = 0; // in ms
const DURATION = 3000;
const SIZE = 64;

const random = (min, max) => Math.floor(Math.random() * (max - min) + min);
const emojiSources = [
  {
    alt: "😄",
    src: "https://fonts.gstatic.com/s/e/notoemoji/latest/1f604/512.gif",
  },
  {
    alt: "👍",
    src: "https://fonts.gstatic.com/s/e/notoemoji/latest/1f44d/512.gif",
  },
  {
    alt: "😍",
    src: "https://fonts.gstatic.com/s/e/notoemoji/latest/1f60d/512.gif",
  },
  {
    alt: "🎉",
    src: "https://fonts.gstatic.com/s/e/notoemoji/latest/1f389/512.gif",
  },
  {
    alt: "❤",
    src: "https://fonts.gstatic.com/s/e/notoemoji/latest/2764_fe0f/512.gif",
  },
];

const EmojiContainer = ({ emojiFireDict }) => {
  const appSingleton = new AppSingleton();
  const [animatedEmoji, setAnimatedEmoji] = useState({ emoji: "", config: {} }); // To randomly set values in the objectConfig
  const [flyingObjects, setFlyingObjects] = useState([]); // Used to manage all flying currently objects by the Fly component
  const defaultAniamtionConfig = {
    left: {
      fromValue: 100,
      toValue: 900,
      duration: DURATION,
      easing: Easing.elastic(5),
      delay: DELAY,
    },
    bottom: {
      fromValue: 0,
      toValue: appSingleton.windowSize.height * 0.8,
      duration: DURATION,
      easing: Easing.linear,
      delay: DELAY,
    },
    opacity: {
      fromValue: 1,
      toValue: 0,
      duration: DURATION,
      easing: Easing.exp,
      delay: DELAY,
    },
  };

  const triggerEmojiAnimation = ({ src, alt }) => {
    const _randomBottom = random(
      appSingleton.windowSize.width * 0.1,
      appSingleton.windowSize.width * 0.9
    );
    setAnimatedEmoji({
      emoji: (
        <img
          style={{ width: `${SIZE}px`, height: "auto" }}
          src={src}
          alt={alt}
        />
      ),
      config: {
        ...defaultAniamtionConfig,
        left: {
          ...defaultAniamtionConfig.left,
          fromValue: _randomBottom,
          toValue:
            _randomBottom +
            appSingleton.windowSize.width *
              0.02 *
              (Math.random() > 0.5 ? -1 : 1),
        },
      },
    });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const randomEmoji =
        emojiSources[Math.floor(Math.random() * emojiSources.length)];
      triggerEmojiAnimation({ ...randomEmoji });
    }, 8000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    const key = emojiFireDict.key;
    emojiSources.forEach((el) => {
      if (el.alt === key) {
        triggerEmojiAnimation({ src: el.src, alt: el.alt });
      }
    });
  }, [emojiFireDict]);

  return (
    <Box>
      <Fly
        objectToFly={animatedEmoji.emoji}
        objectConfig={animatedEmoji.config}
        flyingObjects={flyingObjects}
        setFlyingObjects={setFlyingObjects}
      />
      <Stack direction="row" spacing={8}>
        {emojiSources.map(({ alt, src }) => (
          <Box
            sx={{
              width: `${SIZE * 1.5}px`,
              height: `${SIZE * 1.5}px`,
              borderRadius: "50%",
              bgcolor: "#F5F5F5",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              pointerEvents: "auto",
            }}
          >
            <img
              style={{ width: `${SIZE}px`, height: "auto" }}
              src={src}
              alt={alt}
              onClick={() => {
                // triggerEmojiAnimation({ src, alt });
                sendEmojiAPI({ roomId: "", alt }).then(({ data }) => {
                  // console.log("sendEmojiAPI");
                  // console.log(data);
                });
              }}
            />
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export { EmojiContainer };
